import React from "react"
import { AFrameScene } from "../lib/aframe-components"
import { BuyButton } from "../lib/material-ui-components"
import {SceneComponents} from './scene-components'
import html from "./scene.html"
import COLORS from '../lib/colors'

const Scene = () => (
  <>
    <BuyButton 
      bgColor={COLORS.black} 
      iconColor={COLORS.white}
      url="https://arkivistinc.betterworld.org/auctions/art-auction-benefiting-st-jude-h/items/medusa"
    />
    <AFrameScene 
      sceneHtml={html}
      imageTargets={['jo-target']}
      components={SceneComponents}
    />
  </>
)

export { Scene }
